export default {"src":"/_next/static/media/add-user.5a533bf6.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};